import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../../services/firebase";

// Same naming as the other dashboard uploads: shop/{timestamp}_{name}
export const uploadShopImage = async (file: File): Promise<string> => {
  const fileName = `shop/${Date.now()}_${file.name.replace(/[^a-zA-Z0-9._-]/g, "")}`;
  const snapshot = await uploadBytes(ref(storage, fileName), file, { contentType: file.type || "image/jpeg" });
  return getDownloadURL(snapshot.ref);
};
